// extracted by mini-css-extract-plugin
export default {"splash":"splash-screen_splash__+5SJU","content":"splash-screen_content__QnEWZ","baseline":"splash-screen_baseline__gnRUf","greetings":"splash-screen_greetings__L8Uew"};